export const commonConfig = {
  classicHeader: false,
};
